import _ from 'lodash';
import moment from 'moment';


export default class ParkerAccessDevice {
  fields = {
    type: {
      value: null
    },
    device_identifier: {
      value: null
    },
    device_status: {
      value: null
    },
    device_date_added: {
      value: moment().format('MM/DD/YYYY')
    },
    device_date_active: {
      value: null
    },
    device_date_inactive: {
      value: null
    },
    device_inactive_reason: {
      value: null
    },
  };


  static createFromQueryValues(values) {
    const parkerAccessDevice = new this();

    for (let field in parkerAccessDevice.fields) {
      if (values.hasOwnProperty(field)) {
        switch (field) {
          default:
            parkerAccessDevice.fields[field].value = values[field];
        }
      }
    }

    return parkerAccessDevice;
  }


  getQueryFieldValues() {
    const values = _.cloneDeep(ParkerAccessDeviceInput);

    for (let field in values) {
      switch (field) {
        default:
          values[field] = this.fields[field].value;
      }
    }

    return values;
  }
}


export const ParkerAccessDeviceInput = {
  type: null,
  device_identifier: null,
  device_status: null,
  device_date_added: moment().format('MM/DD/YYYY'),
  device_date_active: null,
  device_date_inactive: null,
  device_inactive_reason: null,
}
